import { Grid } from "@mui/material";
import React, { FunctionComponent } from "react";
import theme from "Theme/AppTheme";
import AcxDisabledAudioControls from "./AcxDisabledAudioControls";

const AcxNoAccessMediaPlayer: FunctionComponent = () => {
    return (
        <Grid
            container
            height={"200px"}
            sx={{ backgroundColor: theme.palette.primary[50] }}
            borderRadius={theme.shape.borderRadius * 0.5}
            marginBottom={theme.spacing(2)}
            boxShadow={
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);"
            }
        >
            <Grid
                container
                item
                xs={12}
                justifyContent={"center"}
                alignContent={"center"}
                alignItems={"center"}
                textAlign={"center"}
                height={"132px"}
            >
                <Grid
                    container
                    item
                    xs={12}
                    justifyContent={"center"}
                    fontSize={"14px"}
                    fontWeight={600}
                >
                    Looks like you don't have access to this audio.
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    justifyContent={"center"}
                    fontSize={"14px"}
                    color={theme.palette.gray.main}
                    maxHeight={"21px"} // prevents style issue on very small width screens
                >
                    To access call recordings, please contact your administrator
                    or check your permissions.
                </Grid>
            </Grid>
            <Grid
                container
                paddingTop={"14px"}
                paddingRight={theme.spacing(2)}
                paddingLeft={theme.spacing(2)}
                justifyContent={"center"}
                sx={{
                    backgroundColor: theme.palette.white.main,
                    borderBottomLeftRadius: theme.shape.borderRadius * 2,
                    borderBottomRightRadius: theme.shape.borderRadius * 2,
                }}
            >
                <AcxDisabledAudioControls />
            </Grid>
        </Grid>
    );
};

export default AcxNoAccessMediaPlayer;
